import type { EnvironmentId } from "@cmmd-forge/contracts";

import type { CloudEnvironmentCatalogRow } from "../../cmmd/cmmdForgeRuntimeListResource";
import { runThreadExecutionIntentAction } from "../../lib/runThreadExecutionIntentAction";
import { newCommandId } from "../../lib/utils";

export async function wakeCloudEnvironmentFromExecutionIntent(
  environment: CloudEnvironmentCatalogRow,
  onWaiting?: (message: string) => void,
): Promise<void> {
  return wakeCloudRuntimeFromExecutionIntent({
    environmentId: (environment.cmmdEnvironmentId ?? environment.environmentId) as EnvironmentId,
    runtimeId: environment.runtimeId,
    ...(onWaiting ? { onWaiting } : {}),
  });
}

export async function wakeCloudRuntimeFromExecutionIntent(input: {
  readonly environmentId: EnvironmentId;
  readonly runtimeId: string;
  readonly onWaiting?: (message: string) => void;
}): Promise<void> {
  await runThreadExecutionIntentAction(
    input.environmentId,
    {
      runtimeId: input.runtimeId,
      action: "wake",
      projectId: null,
      targetId: null,
      dispatchIdentity: newCommandId(),
      ...(input.onWaiting ? { onWaiting: input.onWaiting } : {}),
    },
    { dispatch: async () => undefined },
  );
}
